<template>
  <div class="main">
    <div class="title">正式版</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="用户反馈" name="feedback"></el-tab-pane>
      <!-- <el-tab-pane label="满意度调查" name="satisfaction"></el-tab-pane> -->
      <el-tab-pane label="访问量统计" name="count"></el-tab-pane>
    </el-tabs>
    <!-- 用户反馈 -->
    <div v-if="activeName == 'feedback'">
      <div style="display: flex;align-items: center;">
        <div>
          <el-date-picker value-format="yyyy-MM-dd hh:mm:ss" v-model="timeRange" type="datetimerange" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" @click="searchData">查询</el-button>
        </div>
        <el-button type="text" style="margin-left: 50px;" @click="toDownloadTemplate"><i
            class="el-icon-download"></i>导出数据</el-button>
      </div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="typeStr" label="问题类型" width="180">
        </el-table-column>
        <el-table-column prop="name" label="提交人" width="180">
        </el-table-column>
        <el-table-column prop="phone" label="提交人电话" width="180">
        </el-table-column>
        <el-table-column prop="createTime" label="提交人时间" width="180">
        </el-table-column>
        <el-table-column prop="problemDescribe" label="问题描述">
        </el-table-column>
        <el-table-column prop="followUp" label="是否回访" width="180">
          <template slot-scope="scope">
            <span v-if="scope.row.followUp == 0" style="color: #cf4f40;">未回访</span>
            <span v-else-if="scope.row.followUp == 1" style="color: #9bc687;">已回访</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button :disabled="scope.row.followUp == 1" type="text" class="btn"
              @click="checkStatus(scope.row)">确认回访</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.pageNum"
        :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
      </el-pagination>
    </div>
    <!-- 满意度调查 -->
    <div v-else-if="activeName == 'satisfaction'">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="customerName" label="客户姓名">
        </el-table-column>
        <el-table-column prop="customerPhone" label="客户联系方式">
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间">
        </el-table-column>
        <el-table-column prop="customerPhone" label="分享人电话">
        </el-table-column>
        <el-table-column prop="projectManager" label="项目经理">
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称">
        </el-table-column>
        <el-table-column prop="customerSatisfaction" label="整体满意度">
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <div class="btn" @click="getDetailPdf(scope.row)"><i class="el-icon-view"></i>查看</div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page.pageNum"
        :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
      </el-pagination>
    </div>
    <!-- 访问量统计 -->
    <div v-else-if="activeName == 'count'" class="count">
      <div>访问指标概况</div>
      <!-- <div class="times">累计近7日 2023-12-18-2023-12-24</div> -->
      <!-- <div class="times">累计近7日 {{ countData[showIndex].refDate }}</div> -->
      <el-dropdown @command="handleCommand">
        <span class="times el-dropdown-link">
          累计一周 {{ countData[showIndex].refDate }}<i class="el-icon-arrow-down el-icon--right times"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(item, index) in countData" :key="item.refDate" :command="index">{{ item.refDate
          }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <div class="mainCont">
        <div class="item">
          <div>打开次数</div>
          <div><span>{{ countData[showIndex].sessionCnt }}</span>次</div>
        </div>
        <div class="item">
          <div>访问人数</div>
          <div><span>{{ countData[showIndex].visitUv }}</span>人</div>
        </div>
        <div class="item">
          <div>访问次数</div>
          <div><span>{{ countData[showIndex].visitPv }}</span>次</div>
        </div>
        <div class="item">
          <div>新增用户</div>
          <div><span>{{ countData[showIndex].visitUvNew }}</span>人</div>
        </div>
      </div>
      <div class="mainCont">
        <div class="item">
          <div>次均停留时长</div>
          <div><span>{{ parseInt(countData[showIndex].stayTimeSession) }}</span>秒</div>
        </div>
        <div class="item">
          <div>人均停留时长</div>
          <div><span>{{ parseInt(countData[showIndex].stayTimeUv) }}</span>秒</div>
        </div>
        <!-- <div class="item">
          <div>平均访问深度 </div>
          <div><span>{{ countData.visitDepth }}</span>人</div>
        </div> -->
        <div class="item" style="border: none;"></div>
        <div class="item" style="border: none;"></div>
      </div>
    </div>
    <el-dialog class="ts_c" title="问卷预览" :visible.sync="dialogVisible" width="60%" append-to-body>
      <satisfaction :enterData="enterData" ref="satisfaction" />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="success" @click="$refs.satisfaction.handlePrint()">打印</el-button>
        <el-button size="small" type="primary" @click="$refs.satisfaction.getPdf()">下载</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { searchCardDataSearch, searchCardDataExport, querySurvey, getWechatCount, followUpVerify } from "@/api/home.js";
import { saveAs } from 'file-saver';
import satisfaction from "@/components/satisfaction.vue";

export default {
  name: "feedback",
  components: {
    satisfaction
  },
  data() {
    return {
      page: {
        pageSize: 10,// 每页显示条数
        pageNum: 1,// 页码
        total: 0,// 页码
      },
      tableData: [],
      activeName: 'feedback',
      dialogVisible: false, // 弹框
      enterData: {},
      countData: {},
      showIndex: 0,
      timeRange: []
    }
  },
  mounted() {
    // this.getList()
    this.innitDate()
  },
  methods: {
    checkStatus(row) {
      console.log('row', row)
      followUpVerify({ id: row.id }).then(res => {
        console.log('res', res)
        if (res.code == 200) {
          this.$message.success('修改成功')
          setTimeout(() => {
            this.getList()
          }, 500)
        }
      })
    },
    searchData() {
      this.getList()
    },
    innitDate() {
      const startTime = new Date()
      // 需要查询最近几天，就将下面的3改成几就可以了（以当前时间推算，往前推天数）
      const pastTime = new Date(startTime.getTime() - 3600 * 1000 * 24 * 3)
      const dateValue = []
      dateValue.push(this.getTime(pastTime), this.getTime(startTime))
      // 选择框 v-model绑定的对象
      this.timeRange = dateValue
      this.getList()
    },
    // 时间戳转换：年-月-日 时:分:秒
    getTime(time) {
      const lastY = time.getFullYear();
      const lastM = time.getMonth() + 1;
      const lastD = time.getDate();
      const hour = time.getHours();
      const minute = time.getMinutes();
      const second = time.getSeconds();
      const data =
        lastY +
        '-' +
        (lastM < 10 ? '0' + lastM : lastM) +
        '-' +
        (lastD < 10 ? '0' + lastD : lastD) +
        ' ' +
        (hour < 10 ? '0' + hour : hour) +
        ':' +
        (minute < 10 ? '0' + minute : minute) +
        ':' +
        (second < 10 ? '0' + second : second);
      return data;
    },
    handleCommand(command) {
      this.showIndex = command
    },
    getDetailPdf(row) {
      this.enterData = row
      this.dialogVisible = true
    },
    onSave() { },
    handleClick(tab, event) {
      this.page = {
        pageSize: 10,
        pageNum: 1,
        total: 0,
      }
      this.tableData = []
      this.getList()
    },
    toDownloadTemplate() {
      searchCardDataExport().then((response) => {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, '用户反馈信息表.xls'); // 使用file-saver库保存文件
      });
    },
    getList() {
      if (this.activeName == 'feedback') {
        let params = {
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
        }
        console.log('this.timeRange', this.timeRange)
        if (this.timeRange && this.timeRange.length == 2) {
          params.startTime = this.timeRange[0]
          params.endTime = this.timeRange[1]
        }
        searchCardDataSearch(params).then(res => {
          if (res.code == 200) {
            this.tableData = res.data.records
            this.page.total = res.data.total
          }
        })
      } else if (this.activeName == 'satisfaction') {
        querySurvey({
          pageNum: this.page.pageNum,
          pageSize: this.page.pageSize,
        }).then(res => {
          if (res.code == 200) {
            this.tableData = res.data.records
            this.page.total = res.data.total
          }
        })
      } else if (this.activeName == 'count') {
        let params = {
          proximateWeek: 6//最近6周数据
        }
        getWechatCount(params).then(res => {
          console.log('res', res)
          this.countData = res.data
          this.showIndex = 0
        })
      }
    },
    handleSizeChange(page) {
      this.page.pageSize = page;
      this.getList(this.page);
    },
    handleCurrentChange(page) {
      this.page.pageNum = page;
      this.getList(this.page);
    },
  },
};
</script>

<style lang="scss">
.main {
  padding: 20px;

  .el-table {
    max-height: 800px;
    overflow-y: auto;
  }

  .el-pagination {
    text-align: right;
    margin-top: 20px;
  }
}

.title {
  font-size: 20px;
}

// 访问量统计
.count {
  font-size: 20px;

  .times {
    font-size: 16px;
    color: #bebebe;
  }
}

.mainCont {
  display: flex;
  margin-top: 15px;

  .item {
    font-size: 18px;
    flex: 1;
    border-left: 1px solid #e5e5e5;
    padding: 10px 20px;

    span {
      font-size: 25px;
      font-weight: 700;
    }
  }
}

.btn {
  color: #409eff;
  cursor: pointer;
  font-size: 15px;

  i {
    font-size: 15px;
    padding: 0 5px;
  }
}

// .el-dialog__body {
//   max-height: 80vh !important;
//   overflow: hidden;
//   overflow-y: auto;
// }
</style>